import React, { Component } from 'react';
import { connect } from 'react-redux'
import { courseActions } from '../actions';

import { CardBody, Card, Row, Col } from 'reactstrap';

import MaterialTable from 'material-table';
  
import { CenterMessageCard } from 'components/CenterMessageCard';
import { LoadingPage } from 'components/LoadingPage'


import './CourseCalif.css';

var Utils = require ('Utils');
var viewActions = require ('store/view.actions');


class CourseCalif extends Component {
       componentDidMount() {
         
        this.props.getSchoolCourse(this.props.token, this.props.match.params.id, this.props.currentCalendarID);
        this.props.getSubjects(this.props.token, this.props.match.params.id) ;
        this.props.getCourseEvaluations ( this.props.token, this.props.match.params.id) ;
        this.props.setMainTitle('Cargando datos...', [] );

        
      }


 
      isAuth () {
        // if(this.props.user.user_type === 'TUTOR') {
            // if (this.props.course.tutors.find((tutor) => tutor.persona_id === this.props.user.persona_id)) {
            //   return true;
            // } else {
            //   return false;
            // }
        // } else {
           return true;
        // }
      }

      getStudentEvals ( personaID ) {
        return this.props.courseEvaluations?.find( st => st.persona_id === personaID ) ;
      }

      getStudentSubjectEvals ( evaluations, courseSubjectID ) {

        let ev =  evaluations?.filter( ev => ev.course_subject_id === courseSubjectID ) ;
        return ev ;
      }

      getRows() {
        return this.props.course.students.map( (student) => {
          let studentEvals =  this.getStudentEvals( student.persona_id) ;

          let obj =  { studentName: Utils.capitalize( student.last_name + ", " + student.name ) } 
          
          // Va duplicado para poder manejar correctamente el export.
          if (this.props.courseSubjects) {
            this.props.courseSubjects.map( ( subject ) =>  {
                let cal = this.getStudentSubjectEvals ( studentEvals.evaluations,subject.course_subject_id ) ;
                obj[subject.subject_id] = cal?.map( (it) =>  (it.short_name?it.short_name:it.qualif_value_nbr).concat(' ')  );
                obj[subject.subject_id+'_'] =  cal;
                return null;
              }
            )
          }
          return obj; 
        } )
      }

      myCustomRender ( eva ) {
        return (
          eva && 
          eva.map( (ev, idx) => 
              <>
                {(idx>0?"/":"")}
                <span style={{color:ev.color, cursor:(ev.comments?"pointer":""), textDecoration:(ev.comments?"underline":"") }}  
                      title={ev.comments} 
                      >
                        {ev.short_name?ev.short_name:ev.qualif_value_nbr}
                </span>
              </>
          )
        )

      }

      getColumns () {
       
        let columns = this.props.courseSubjects?.map( ( subject, idx ) => {
          let ancho = 80 / this.props.courseSubjects.length ;
          return (
            { width: ancho+"%" , 
              title: subject.long_name, 
              field: subject.subject_id,
              render: rowData => this.myCustomRender(rowData[subject.subject_id+"_"] )
           }
            )
        })
      
        columns.unshift({ width: '20%', title: 'Alumno', field: 'studentName'});
        
        return columns ;
      }
  

      //

     render() {
      
      return (
          <>
          {( this.props.course.course_id  && this.props.courseSubjects && this.props.courseSubjects[0] ) 
                &&!this.props.view.loadingModules.getSchoolCourse &&!this.props.view.loadingModules.getCourseEvaluations?
             <>
              {this.isAuth()?
                <div className="content"> 
                <Card>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                          <MaterialTable
                              title={this.props.view.mainTitle}
                              columns={ this.getColumns() }
                              data={ this.getRows() }        
                              options={{
                                  exportButton: true,
                                  search: false,
                                  paging: false,

                                  headerStyle: { position: 'sticky', top: 0 }, 
                                  maxBodyHeight: '650px',
                                  rowStyle: x => {
                                    if (x.tableData.id % 2) {
                                        return {backgroundColor: "#f2f2f2"}
                                    }
                                }
                              }}
                              localization={{
                                  toolbar: {
                                    exportCSVName: "Exportar CSV",
                                    exportPDFName: "Exportar PDF"
                                  }
                                }}
                          />
                      </Col>
                    </Row>
                  
                  </CardBody>
                </Card></div>
              :
                <CenterMessageCard 
                    icon="fa-info"
                    title="Autorización requerida">
                      No tenés permisos para acceder a este curso. En caso que lo requieras solicita al administrador que 
                      te agregue como tutor
                      de <b>{'Curso ' + this.props.course.name + " - Turno: " + this.props.course.shift_name }</b>
                </CenterMessageCard>  
               }
              </>
              :
              <LoadingPage 
                title="Cargando curso"/>
              } 
           </> 
            
          );
    }
  }


  const mapStateToProps = state => {
    return {
        course: state.courses.course,
        courseSubjects: state.courses.courseSubjects,
        token: state.auth.session.jwt_token,
        currentCalendarID: state.school.currentCalendarID,
        courseEvaluations: state.courses.courseEvaluations,
        view: state.view,
        user: state.auth.session.user
    }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getSchoolCourse: (token, courseID, calendarID) => {
          dispatch(courseActions.getSchoolCourse(token, courseID, calendarID));
        } ,
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle(title, menu)) ;
        },
        getSubjects: ( token, courseID ) => {
          dispatch(courseActions.getSubjects(token, courseID));
        },
        getCourseEvaluations: ( token, courseID ) => {
          dispatch(courseActions.getCourseEvaluations( token, courseID )) ;
        }


     }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(CourseCalif);

